export default __webpack_public_path__ + "static/media/dark_thumsUP.478257c5.svg";